// Embedded Videos Handler
window.EmbeddedVideos = {
  version: '1.0.3',
  activePolling: null,
  observers: {},
  init: function() {
    this.setupEventListeners();
    this.loadAllVideos();
  },
  
  setupEventListeners: function() {
    // Keep track of completed initialization
    if (window.EmbeddedVideos.listenersInitialized) return;
    window.EmbeddedVideos.listenersInitialized = true;
    
    // Manually hook into Shopify's variant change mechanism
    const originalHistoryPushState = window.history.pushState;
    window.history.pushState = function() {
      window.EmbeddedVideos.loadAllVideos();
      return originalHistoryPushState.apply(this, arguments);
    };
    
    // Listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', function() {
      window.EmbeddedVideos.loadAllVideos();
    });
    
    // Listen for all known Shopify variant events
    ['variant:change', 'shopify:section:load', 'product:loaded', 'variant:updated', 'variantChanged']
      .forEach(function(eventName) {
        document.addEventListener(eventName, function() {
          window.EmbeddedVideos.loadAllVideos();
        });
      });
    
    // Listen for click events on variant selectors
    document.addEventListener('click', function(e) {
      if (e.target.matches('input[type="radio"][name^="options"], select[name^="options"], .swatch input, .product-form__input input, .js-option, .single-option-selector')) {
        // Use a longer timeout to ensure the page has updated
        setTimeout(window.EmbeddedVideos.loadAllVideos, 500);
      }
    });
    
    // Refresh button handler
    document.addEventListener('click', function(e) {
      if (e.target.matches('.video-refresh-button')) {
        window.EmbeddedVideos.loadAllVideos(true); // Force reload
      }
    });
    
    // Listen for messages from YouTube iframes
    window.addEventListener('message', function(event) {
      // Check if message is from YouTube
      if (event.origin !== 'https://www.youtube.com') return;
      
      try {
        const data = JSON.parse(event.data);
        // Check if this is a player state change event
        if (data.event === 'onStateChange') {
          // Find the container for this iframe
          const iframe = document.querySelector('iframe[src*="' + data.id + '"]');
          if (iframe) {
            const container = iframe.closest('.video-container');
            // If video was played by user (state 1 = playing)
            if (data.info === 1) {
              container.setAttribute('data-user-played', 'true');
            }
          }
        }
      } catch (e) {
        // Not a JSON message or other error, ignore
      }
    });
  },
  
  loadAllVideos: function(forceReload = false) {
    // Cancel any existing polling
    if (this.activePolling) {
      clearInterval(this.activePolling.intervalId);
      this.activePolling = null;
    }
    
    // Disconnect any existing observers
    Object.values(this.observers).forEach(observer => {
      if (observer && typeof observer.disconnect === 'function') {
        observer.disconnect();
      }
    });
    this.observers = {};
    
    // Set up polling to check for videos multiple times
    let attempts = 0;
    const maxAttempts = 10;
    const checkInterval = 800; // ms between checks
    
    const processVideos = function() {
      // Find all video containers
      const videoContainers = document.querySelectorAll('.video-container');
      
      if (videoContainers.length === 0) {
        return; // No videos to process
      }
      
      // Track first video for special handling
      let firstVideoContainer = videoContainers[0];
      let firstVideoProcessed = false;
      
      // If forcing reload, reset all containers
      if (forceReload) {
        videoContainers.forEach(container => {
          container.innerHTML = '';
          container.removeAttribute('data-loaded');
          container.removeAttribute('data-paused-by-scroll');
          container.removeAttribute('data-user-played');
        });
      }
      
      // Set up IntersectionObserver for viewport-based loading
      if ('IntersectionObserver' in window) {
        const observerId = 'video-observer-' + Date.now();
        window.EmbeddedVideos.observers[observerId] = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const container = entry.target;
            const videoId = container.getAttribute('data-video-id');
            
            if (!videoId) return;
            
            // Handle special case for first video
            const isFirstVideo = container === firstVideoContainer;
            
            // Check if this video was played by user or autoplayed
            const wasAutoplayed = container.hasAttribute('data-autoplay-enabled');
            const wasUserPlayed = container.hasAttribute('data-user-played');
            
            // Video is in viewport and not loaded yet
            if (entry.isIntersecting && !container.hasAttribute('data-loaded')) {
              // If this is the first video and we haven't processed it yet,
              // load it with potential autoplay
              if (isFirstVideo && !firstVideoProcessed) {
                window.EmbeddedVideos.loadSingleVideo(container, true); // Enable autoplay for first video
                firstVideoProcessed = true;
              } else {
                window.EmbeddedVideos.loadSingleVideo(container, false); // No autoplay for other videos
              }
            }
            // Video is in viewport and was previously paused - only resume if autoplayed or user played it
            else if (entry.isIntersecting && container.hasAttribute('data-paused-by-scroll') && 
                    (wasAutoplayed || wasUserPlayed)) {
              const iframe = container.querySelector('iframe');
              if (iframe && iframe.contentWindow) {
                // Resume video playback
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                container.removeAttribute('data-paused-by-scroll');
              }
            }
            // Video is out of viewport and loaded - pause it
            else if (!entry.isIntersecting && container.hasAttribute('data-loaded')) {
              const iframe = container.querySelector('iframe');
              if (iframe && iframe.contentWindow) {
                // Pause video
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                container.setAttribute('data-paused-by-scroll', 'true');
              }
            }
          });
        }, {
          rootMargin: '0px',
          threshold: 0.2
        });
        
        // Always load first video even if not in viewport
        if (firstVideoContainer && !firstVideoContainer.hasAttribute('data-loaded') && 
            firstVideoContainer.getAttribute('data-autoplay') === 'true') {
          window.EmbeddedVideos.loadSingleVideo(firstVideoContainer, true);
          firstVideoProcessed = true;
        }
        
        // Observe all video containers
        videoContainers.forEach(container => {
          window.EmbeddedVideos.observers[observerId].observe(container);
        });
      } else {
        // Fallback for browsers without IntersectionObserver
        videoContainers.forEach((container, index) => {
          if (!container.hasAttribute('data-loaded')) {
            const isFirst = index === 0;
            window.EmbeddedVideos.loadSingleVideo(container, isFirst);
          }
        });
      }
      
      // Process title elements
      const titleElements = document.querySelectorAll('.embedded-video-title-loading:not([data-processed])');
      
      titleElements.forEach(function(element) {
        element.setAttribute('data-processed', 'true');
        const videoId = element.getAttribute('data-video-id');
        
        if (!videoId) return;
        
        fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
          .then(response => response.json())
          .then(data => {
            element.innerHTML = '<span>' + data.title + '</span>';
            element.classList.remove('embedded-video-title-loading');
            element.classList.add('embedded-video-title');
          })
          .catch(() => {
            element.innerHTML = '<span>Video</span>';
            element.classList.remove('embedded-video-title-loading');
            element.classList.add('embedded-video-title');
          });
      });
      
      // Initialize slider if present
      window.EmbeddedVideos.initializeSlider();
      
      // Increment attempts count
      attempts++;
      
      // Cancel polling if we've reached max attempts
      if (attempts >= maxAttempts) {
        clearInterval(window.EmbeddedVideos.activePolling.intervalId);
        window.EmbeddedVideos.activePolling = null;
      }
    };
    
    // Process immediately
    processVideos();
    
    // Then set up interval for continued checking
    const intervalId = setInterval(processVideos, checkInterval);
    this.activePolling = { intervalId, attempts, maxAttempts };
  },
  
  loadSingleVideo: function(container, allowAutoplay) {
    if (container.hasAttribute('data-loaded')) return;
    
    const videoId = container.getAttribute('data-video-id');
    if (!videoId) return;
    
    // Get video parameters
    const mute = container.getAttribute('data-mute') === 'true';
    const controls = container.getAttribute('data-controls') === 'true';
    
    // Only enable autoplay if explicitly allowed AND configured in the container
    const autoplay = allowAutoplay && container.getAttribute('data-autoplay') === 'true';
    
    // Build YouTube URL with API parameters to detect play/pause events
    let src = `https://www.youtube.com/embed/${videoId}?rel=0&enablejsapi=1&origin=${window.location.origin}`;
    if (autoplay) src += '&autoplay=1';
    if (mute) src += '&mute=1';
    if (!controls) src += '&controls=0';
    
    // Create and add iframe
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = 'Embedded YouTube video';
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    
    // Clear container and add iframe
    container.innerHTML = '';
    container.appendChild(iframe);
    container.setAttribute('data-loaded', 'true');
    
    // Add a special attribute for autoplay videos
    if (autoplay) {
      container.setAttribute('data-autoplay-enabled', 'true');
    }
  },
  
  initializeSlider: function() {
    const sliders = document.querySelectorAll('.embedded-videos-slider');
    
    sliders.forEach(function(slider) {
      if (slider.hasAttribute('data-slider-initialized')) {
        return; // Skip already initialized sliders
      }
      
      const track = slider.querySelector('.embedded-videos-track');
      const slides = Array.from(slider.querySelectorAll('.embedded-video-wrapper'));
      const prevButton = slider.querySelector('.slider-button--prev');
      const nextButton = slider.querySelector('.slider-button--next');
      
      if (!slides.length) return;
      
      let currentIndex = 0;
      
      // Set initial slide positions
      slides.forEach((slide, index) => {
        slide.style.transform = `translateX(${100 * (index - currentIndex)}%)`;
      });
      
      // Update slide positions and button states
      function updateSlides() {
        slides.forEach((slide, index) => {
          slide.style.transform = `translateX(${100 * (index - currentIndex)}%)`;
        });
        
        if (prevButton) {
          prevButton.disabled = currentIndex === 0;
          prevButton.style.opacity = currentIndex === 0 ? '0.5' : '1';
        }
        
        if (nextButton) {
          nextButton.disabled = currentIndex === slides.length - 1;
          nextButton.style.opacity = currentIndex === slides.length - 1 ? '0.5' : '1';
        }
      }
      
      // Set up button listeners
      if (prevButton) {
        prevButton.addEventListener('click', function() {
          if (currentIndex > 0) {
            currentIndex--;
            updateSlides();
          }
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', function() {
          if (currentIndex < slides.length - 1) {
            currentIndex++;
            updateSlides();
          }
        });
      }
      
      // Initialize
      updateSlides();
      slider.setAttribute('data-slider-initialized', 'true');
    });
  }
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  window.EmbeddedVideos.init();
});

// Also initialize after a short delay to catch any late-loading content
setTimeout(function() {
  window.EmbeddedVideos.init();
}, 1000); 